<template>
    <layout v-bind:user="user" v-bind:company="company" v-bind:brands="brands" v-bind:shops="shops" title="会員登録時価値軸" @selectList="displaySelectedBrand($event)">
        <main class="ly_main">
            <div class="wrap">
                <div class="inner">
                    <!--Heading-->
                    <h1 class="heading_page-title flex _y-center">
                        <div class="main"><span>会員登録時価値軸</span></div>
                    </h1><!--/.heading_page-title-->

                    <section>
                        <form v-on:submit.prevent="newsPost">

                            <div class="axis_component md_common-bl _padding-add">
                                <div class="inner">

                                    <!-- Genre -->
                                    <div class="row-item _genre">
                                        <div class="title"><span>取り扱い商品のジャンル登録</span></div>
                                        <div class="detail"><span>{{pageList.first_category.name}}</span></div>
                                    </div>

                                    <!-- Category -->
                                    <div class="row-item _category">
                                        <div class="title"><span>取り扱い商品のカテゴリ登録</span></div>
                                        <div class="detail">
                                            <span v-for="category in pageList.price_zone_guidelines">
                                                {{category.select_category.name}}
                                            </span>
                                        </div>
                                    </div>

                                    <template v-if="!editPage">
                                        <!-- Edit -->
                                        <div class="edit-item-wrap">
                                            <div class="title">取り扱い商品種類と価値軸</div>

                                            <!-- SelectItemWrap -->
                                            <div class="select-item-wrap">

                                                <!-- Item -->
                                                <div class="select-row" v-for="category in guidelines">
                                                    <div class="title"><span>{{category.select_category.name}}</span></div>
                                                    <div class="item form_select">
                                                        <p><span>{{category.price_range}}</span></p>
                                                    </div>
                                                    <div class="detail">
                                                        <span v-if="category.price_rank == 1">Standard</span>
                                                        <span v-if="category.price_rank == 2">Highclass</span>
                                                        <span v-if="category.price_rank == 3">Luxury</span>
                                                    </div>
                                                </div>

                                            </div><!-- /SelectItemWrap -->

                                            <div class="result-wrap">
                                                <div class="box">
                                                    <p class="top">AUMAの中でこのブランドの価格軸は</p>
                                                    <p class="middle"><span>{{priceZoneName}}</span></p>
                                                    <p class="bottom">です。</p>
                                                </div>
                                            </div>

                                        </div><!-- /Edit -->
                                        <!-- BtnLinkWrap -->
                                        <div class="btn_link-wrap" v-if="user.type == 0">

                                            <button class="btn_link _cancel md_icon-text" v-on:click="approvalNot">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCancel /></div>承認しない</span>
                                                </div>
                                            </button>

                                            <button class="btn_link md_icon-text _white" v-on:click="approvalOk">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>承認する</span>
                                                </div>
                                            </button>

                                            <button class="btn_link md_icon-text _white" v-on:click="openEditPage">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconEdit /></div>編集する</span>
                                                </div>
                                            </button>

                                        </div><!-- /.BtnLinkWrap -->
                                    </template>

                                    <template v-if="editPage">
                                        <!-- Edit -->
                                        <div class="edit-item-wrap">
                                            <div class="title">取り扱い商品種類と価値軸</div>

                                            <!-- SelectItemWrap -->
                                            <div class="select-item-wrap">

                                                <!-- Item -->
                                                <div class="select-row" v-for="(editCategory, index) in editGuidelines" v-bind:key="index">
                                                    <div class="title"><span>{{editCategory.select_category.name}}</span></div>
                                                    <div class="item form_select">
                                                        <div class="input-row">
                                                            <select v-on:change="selectPriceZoneGuideline($event, editCategory, index)">
                                                                <option hidden>{{editCategory.edit_price_range}}</option>
                                                                <option
                                                                v-for="price_zone_guideline_pull_down in editCategory.price_zone_guideline_pull_down"
                                                                v-bind:key="price_zone_guideline_pull_down.id"
                                                                v-bind:value="price_zone_guideline_pull_down.id"
                                                                >{{ price_zone_guideline_pull_down.price_range }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="detail">
                                                        <span v-if="editCategory.edit_price_rank == 1">Standard</span>
                                                        <span v-if="editCategory.edit_price_rank == 2">Highclass</span>
                                                        <span v-if="editCategory.edit_price_rank == 3">Luxury</span>
                                                    </div>
                                                </div>

                                            </div><!-- /SelectItemWrap -->

                                            <div class="result-wrap">
                                                <div class="box">
                                                    <p class="top">AUMAの中でこのブランドの価格軸は</p>
                                                    <p class="middle"><span>{{editPriceZoneName}}</span></p>
                                                    <p class="bottom">です。</p>
                                                </div>
                                            </div>

                                        </div><!-- /Edit -->
                                        <!-- BtnLinkWrap -->
                                        <div class="btn_link-wrap">

                                            <button class="btn_link _cancel md_icon-text" v-on:click="closeEditPage">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconBack /></div>戻る</span>
                                                </div>
                                            </button>

                                            <button class="btn_link md_icon-text _white" v-on:click="editPost">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>保存する</span>
                                                </div>
                                            </button>

                                        </div><!-- /.BtnLinkWrap -->
                                    </template>

                                </div>
                            </div>
                        </form>

                    </section>

                </div><!--/.ly_main .inner-->
            </div><!--/.ly_main .wrap-->
            <AlertModal
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
            <div class="heading_page-title-en"><span>{{backName}}</span></div>
        </main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            "layout": AdminLayout,
            //Svg
            SvgIconCheck,
            SvgIconCancel,
            SvgIconEdit,
            SvgIconBack,
            "AlertModal": AlertModal,
        },
        data() {
            return {
                editPage: false,
                guidelines: [],
                editGuidelines: [],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        props: {
            brand: Object,
            brands: Object,
            shop: Object,
            shops: Object,
            user: Object,
            company: Object,
        },
        computed: {
            pageList() {
                if (this.shop) {
                    return this.shop;
                } else if (this.brand) {
                    return this.brand;
                }
            },
            pageType() {
                if (this.shop) {
                    return 0;
                } else {
                    return 1;
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                }
            },
            priceZoneName() {
                var sum = 0;
                for(var i in this.guidelines) {
                    var price_zone_guideline = this.guidelines[i];
                    sum = sum + price_zone_guideline.price_rank;
                }
                var ans = sum / this.guidelines.length;
                
                ans = Math.round(ans);
                switch (ans) {
                    case 1:
                        var res = 'Standard';
                        break;
                    case 2:
                        var res = 'Highclass';
                        break;
                    case 3:
                        var res = 'Luxury';
                        break;
                }
                return res;
            },
            editPriceZoneName() {
                var sum = 0;
                for(var i in this.editGuidelines) {
                    var price_zone_guideline = this.editGuidelines[i];
                    sum = sum + price_zone_guideline.edit_price_rank;
                }
                var ans = sum / this.editGuidelines.length;
                
                ans = Math.round(ans);
                switch (ans) {
                    case 1:
                        var res = 'Standard';
                        break;
                    case 2:
                        var res = 'Highclass';
                        break;
                    case 3:
                        var res = 'Luxury';
                        break;
                }
                return res;
            },
        },
        mounted() {
            if (this.shop) {
                //id順に並び替え
                this.shop.price_zone_guidelines = this.shop.price_zone_guidelines.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
                for(var i in this.shop.price_zone_guidelines) {
                    var price_zone_guideline = this.pageList.price_zone_guidelines[i];
                    var edit_price_zone_guideline = this.pageList.price_zone_guidelines[i];
                    this.guidelines.push(price_zone_guideline);
                    edit_price_zone_guideline.edit_id = edit_price_zone_guideline.id;
                    edit_price_zone_guideline.edit_price_rank = edit_price_zone_guideline.price_rank;
                    edit_price_zone_guideline.edit_price_range = edit_price_zone_guideline.price_range;
                    this.editGuidelines.push(price_zone_guideline);
                }
            } else if (this.brand) {
                //id順に並び替え
                this.brand.price_zone_guidelines = this.brand.price_zone_guidelines.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
                for(var i in this.brand.price_zone_guidelines) {
                    var price_zone_guideline = this.pageList.price_zone_guidelines[i];
                    var edit_price_zone_guideline = this.pageList.price_zone_guidelines[i];
                    this.guidelines.push(price_zone_guideline);
                    edit_price_zone_guideline.edit_id = edit_price_zone_guideline.id;
                    edit_price_zone_guideline.edit_price_rank = edit_price_zone_guideline.price_rank;
                    edit_price_zone_guideline.edit_price_range = edit_price_zone_guideline.price_range;
                    this.editGuidelines.push(edit_price_zone_guideline);
                }
            }
        },
        watch: {
            '$page.props': {
                handler(value){
                    if(value.flash.success){
                        const successMessage = value.flash.success.split(",");
                        this.openAlertModal("success", successMessage[0], successMessage[1]); // 確認済み
                    }
                },
                deep: true
            }
        },
        methods: {
            displaySelectedBrand(index) {
                var form = {
                    index: index,
                }

                Inertia.get(location.pathname, form, {
                    preserveScroll: true,
                })
            },
            approvalOk() {

                if (this.pageType == 0) {
                    var id = this.shop.id
                    var url = '/admin/shop/price-zone'
                } else {
                    var id = this.brand.id
                    var url = '/admin/brand/price-zone'
                }

                // 承認
                const form = reactive({
                    id: id,
                    approval: 1,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                    },
                })
            },
            approvalNot() {
                if (this.pageType == 0) {
                    var id = this.shop.id
                    var url = '/admin/shop/price-zone'
                } else {
                    var id = this.brand.id
                    var url = '/admin/brand/price-zone'
                }
                // 非承認
                const form = reactive({
                    id: id,
                    approval: 2,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                    },
                })
            },

            selectPriceZoneGuideline(event, editCategory, index) {
                var select_id = event.target.value;
                var pull_downs = editCategory.price_zone_guideline_pull_down;
                
                var value = pull_downs.filter((pull_down) => {
                    return (pull_down.id == select_id);
                });
                editCategory.edit_id = value[0].id;
                editCategory.edit_price_range = value[0].price_range;
                editCategory.edit_price_rank = value[0].price_rank;
            },

            openEditPage() {
                this.editPage = true;
            },
            closeEditPage() {
                this.editPage = false;
            },
            editPost() {
                if (this.pageType == 0) {
                    var id = this.shop.id
                    var url = '/admin/shop/price-zone/store'
                } else {
                    var id = this.brand.id
                    var url = '/admin/brand/price-zone/store'
                }
                const form = reactive({
                    id: id,
                    editGuidelines: this.editGuidelines,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                    },
                    onFinish: visit => {
                        setTimeout(function() { location.reload(); }, 2000); // modalを見る時間確保
                    },
                })
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            }
        }
    }
</script>
